import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ProjectPriorityAdd from '../../projectPriorityAdd/index';

class ProjectPriorityRow extends React.Component {
    onProjectPriorityOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onProjectPriorityClose = () => {
        this.setState({ addProjectPriorityState: false });
    };
    onDeleteProjectPriority = (org) => {
        this.setState({ addProjectPriorityState: false });
        this.props.onDeleteProjectPriority(org);
    };

    onEditProjectPriority = () => {
        this.setState({ menuState: false, addProjectPriorityState: true });
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            addProjectPriorityState: false,
            deletePriorityCheck: false,
        };
    }

    render() {
        const {
            projectPriority,
            onSaveProjectPriority,
            showProjectPriorityLoader,
            updatingGlobalPriorities,
            projectList,
            showProjectLoader,
            onSaveProject,
            onUpdateProjectPriorities,
        } = this.props;
        const { menuState, addProjectPriorityState, deletePriorityCheck } = this.state;
        const { name, description, value } = projectPriority;
        const options = updatingGlobalPriorities ? ['Edit', 'Delete'] : ['Edit'];
        return (
            <div className="contact-item">
                <div className="col">
                    <p className="mb-0">
                        <span className="contact-name">
                            {name}
                        </span>
                    </p>
                    <div>
                        <span className="job-title">
                            Description - {description ? description : 'No description provided'}
                        </span>
                        {updatingGlobalPriorities ?
                            null
                            : <React.Fragment>
                                <span className="d-inline-block toolbar-separator">&nbsp;</span>
                                <span className="value d-inline-block mr-2">
                                    Value - {value}
                                </span>
                            </React.Fragment>}
                    </div>
                </div>
                <div className="col-auto px-1 actions d-sm-flex">
                    <Dropdown isOpen={menuState}
                        toggle={this.onProjectPriorityOptionToggle.bind(this)}>
                        <DropdownToggle tag="span">
                            <span className="icon-btn text-grey pointer">
                                <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                            </span>
                        </DropdownToggle>

                        <DropdownMenu>
                            {options.map(option =>
                                <DropdownItem key={option} onClick={() => {
                                    if (option === 'Edit') {
                                        this.onEditProjectPriority();
                                    } else if (option === 'Delete') {
                                        this.setState({ deletePriorityCheck: true });
                                    }
                                }
                                }>
                                    {option}
                                </DropdownItem>,
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    {addProjectPriorityState &&
                        <ProjectPriorityAdd
                            showProjectLoader={showProjectLoader}
                            onSaveProject={onSaveProject}
                            projectList={projectList}
                            updatingGlobalPriorities={updatingGlobalPriorities}
                            open={addProjectPriorityState}
                            projectPriority={projectPriority}
                            onSaveProjectPriority={onSaveProjectPriority}
                            onProjectPriorityClose={this.onProjectPriorityClose}
                            onDeleteProjectPriority={this.onDeleteProjectPriority}
                            showProjectPriorityLoader={showProjectPriorityLoader}
                            onUpdateProjectPriorities={onUpdateProjectPriorities}
                        />
                    }
                    <SweetAlert show={deletePriorityCheck}
                        warning
                        showCancel
                        confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                        cancelBtnText={<IntlMessages id="button.cancel" />}
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                        onConfirm={() => {
                            this.onDeleteProjectPriority(projectPriority);
                            this.setState({ deletePriorityCheck: false });
                        }}
                        onCancel={() => {
                            this.setState({ deletePriorityCheck: false });
                        }}
                    >
                        <IntlMessages id="projectPriority.deleteProjectPriority" />
                    </SweetAlert>
                </div>
            </div>
        );
    }
}

export default ProjectPriorityRow;


// WEBPACK FOOTER //
// ./components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js